export default __webpack_public_path__ + "f8ac12082afa0f8a5d467082fb19380f.png";